import PropertiesCardContent from './PropertiesCardContent';
import { PropertiesCardContext } from './PropertiesCardContext';
import { useOnCrmMessageTopic } from 'crm-message-bus/useOnCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { useState } from 'react';
// @ts-expect-error js module
import { getUserCanEdit } from 'customer-data-sidebar/universal/permissions/UserPermissions';
import Raven from 'raven-js';
import { useCrmObject } from '../hooks/useCrmObject';
import PropertiesCardContent_legacy from './PropertiesCardContent_legacy';
import { gate } from 'hub-http/gates';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertiesCardContentWrapper = props => {
  const {
    cardId,
    editableAreas,
    hasScope,
    isEmbedded,
    isUngated,
    objectId,
    objectTypeId,
    onObjectUpdate,
    onSaveSuccess,
    onShowPropertyHistory,
    propertyNames,
    propertySourceInfo,
    readOnly,
    SuccessMarker,
    CardContentLoadingComponent,
    userPermission,
    shouldHideDetailsButton
  } = props;
  const [refetchError, setRefetchError] = useState(undefined);
  const {
    crmObject,
    error,
    loading,
    refetch,
    updateCrmObjectCache
  } = useCrmObject(objectTypeId, objectId);
  useOnCrmMessageTopic(TOPIC_NAMES.UPDATE_OBJECT, objectData => {
    if (normalizeTypeId(objectTypeId) === normalizeTypeId(objectData.objectTypeId) && String(objectId) === objectData.objectId) {
      try {
        refetch().catch(err => {
          setRefetchError(err);
          Raven.captureException(err);
          throw err;
        });
      } catch (err) {
        if (err instanceof Error) {
          Raven.captureException(err, {
            extra: {
              cardId,
              objectId,
              objectTypeId
            }
          });
        }
      }
    }
  }, {
    ignoreLocal: true
  });
  if (loading) {
    return /*#__PURE__*/_jsx(CardContentLoadingComponent, {
      cardId: cardId,
      numberOfSkeletons: propertyNames.length
    });
  }
  const dataFetchingError = error || refetchError;
  if (dataFetchingError || !crmObject) {
    throw dataFetchingError || new Error('No data returned from query');
  }
  const isEditable = !readOnly && getUserCanEdit(crmObject.userPermissions);
  const hasAutosave = isUngated(gate('CRM:Properties:Autosave:PropertiesCard'));
  return /*#__PURE__*/_jsx(PropertiesCardContext.Provider, {
    value: {
      cardId,
      crmObject,
      editableAreas,
      hasScope,
      isEditable,
      isEmbedded: Boolean(isEmbedded),
      isUngated,
      objectId,
      objectTypeId,
      onObjectUpdate,
      onSaveSuccess,
      onShowPropertyHistory,
      propertyNames,
      propertySourceInfo,
      SuccessMarker,
      CardContentLoadingComponent,
      userPermission,
      updateCrmObjectCache,
      shouldHideDetailsButton
    },
    children: hasAutosave ? /*#__PURE__*/_jsx(PropertiesCardContent, {}) : /*#__PURE__*/_jsx(PropertiesCardContent_legacy, {})
  });
};
export default PropertiesCardContentWrapper;